<template>
    <section class=" h-full">
        <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase px-8 py-8">Resultados das Importações</p>
        <section v-if="resultados.length === 0" class="rounded-lg mt-40 dark:text-gray-300 text-gray-500 flex items-center flex-col w-1/2 mx-auto h-min ">
            <span class="material-icons-outlined text-center dark:text-gray-300 text-gray-500 select-none text-9xl ">
                warning_amber
            </span>
            <p class="text-2xl text-center">Não existem resultados, provavelmente você ainda não realizou uma importação ou o arquivo ainda não foi processado.</p>
        </section>
        <div v-else class="w-4/6 h-3/4 mx-auto flex flex-col flex-wrap">
            <div class="bg-gray-200 dark:bg-gray-800 h-12 text-lg flex justify-between items-center px-4 rounded-t-lg dark:text-gray-400 text-gray-700">
                <span>Arquivo</span>
            </div>
            <div class="h-10 w-full bg-yellow-500">
                <p class="text-center leading-10 font-bold dark:text-gray-200 text-gray-100">Os arquivos abaixos são excluídos após 2 dias</p>
            </div>
            <div class="relative flex-auto w-full h-40 bg-gray-200 dark:bg-gray-600 overflow-y-scroll">
                <span v-for="resultado in resultados" :key="resultado" class="flex justify-between items-center px-4 w-full h-12 text-sm border-b border-gray-400 dark:border-gray-700">
                    <a class="truncate font-bold hover:underline cursor-pointer dark:text-gray-400 text-gray-600" :href="resultado" target="_blank">{{resultado}}</a>
                </span>
            </div>
            <div class="bg-gray-200 dark:bg-gray-800 h-8 text-lg flex justify-between items-center rounded-b-lg py-2 shadow-md">
            </div>
        </div>
    </section>
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core'
import Spinner from '../Design/Spinner.vue'
import { RESULTADO_IMPORTACOES } from '../../mixins/api'
export default {
    name: 'ResultadosImportacoes',
    components: {
        Spinner,
    },
    setup() {
        const resultados = ref([])

        onMounted(() => {
            RESULTADO_IMPORTACOES().then(r => {
                
                resultados.value = r.data.resultados
            })
        })

        return {
            resultados,
        }
    }
}
</script>

<style>

</style>